#scolab-switcher-dialog {
    z-index: 999999999;
    position: absolute;
    bottom: 60px;
    left: 50%;
    width: 552px;
    margin-right: 22px;
    transform: translateX(-50%);
    border-radius: 4px;
    color: #fff;
    background: #111213;
    box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.25);
    animation: slidePopup 0.2s ease-out forwards;
}

@keyframes slidePopup {
    100% { bottom: 80px; }
}

#scolab-switcher-dialog .scolab-switcher-dialog-content {
    overflow: auto;
}

#scolab-switcher-dialog .scolab-switcher-dialog-footer {
    display: flex;
    justify-content: flex-end;
    padding: 8px;
    gap: 8px;
}
